export const baseZIndex = 15000;
export const nop = function() {};
